module.exports = __webpack_public_path__ + "img/main.a290e618.jpg";